import type { UserId } from '@/schemas/ids';
import { downloadRemotePlayerEvents } from './download';
import { mergeRemotePlayerEvents } from './merge';
import { uploadPendingPlayerEvents } from './upload';

export interface SyncResult {
  uploadedCount: number;
  downloadedCount: number;
}

export class PlayerEventsSyncError extends Error {
  constructor(
    message: string,
    public readonly userId: UserId,
    public readonly type: 'upload' | 'download' | 'full',
    public readonly originalError: unknown,
  ) {
    super(message);
    this.name = 'PlayerEventsSyncError';
  }
}

export async function syncPlayerEvents(userId: UserId): Promise<SyncResult> {
  try {
    const up = await uploadPendingPlayerEvents(userId);
    const down = await downloadRemotePlayerEvents(userId);
    await mergeRemotePlayerEvents(down.events);
    return { uploadedCount: up.uploaded, downloadedCount: down.events.length };
  } catch (error) {
    throw new PlayerEventsSyncError(
      error instanceof Error ? error.message : 'Player events sync failed',
      userId,
      'full',
      error,
    );
  }
}
